import Content from 'components/common/Content-v2';
import MainTitle from 'components/common/Title';
import LinkButton from 'components/common/LinkButton';
import AddMemberForm from 'components/forms/members/add';
const AddMember = props => {
	return (
		<>
			<MainTitle>
				<h1>Añadir miembro</h1>
				<LinkButton to="/admin/members"> Regresar </LinkButton>
			</MainTitle>
			<Content>
				<AddMemberForm />
			</Content>
		</>
	);
};
export default AddMember;
